import { compact } from 'lodash';
import { twMerge } from 'tailwind-merge';
import { FieldsetProps } from './type';
import { CompoundProps } from '../../types';

const Fieldset = ({
  className,
  children,
  label,
  labelAlt,
  ...rest
}: FieldsetProps) => {
  const altLabels = Array.isArray(labelAlt) ? labelAlt : compact([labelAlt]);

  return (
    <fieldset {...rest} className={twMerge('fieldset', className)}>
      {label && <legend className="fieldset-legend">{label}</legend>}
      {children}
      {altLabels.length > 0 && (
        <div className="flex flex-col gap-0.5">
          {altLabels.map((alt, index) => (
            <label className="fieldset-label text-error" key={index}>
              {alt}
            </label>
          ))}
        </div>
      )}
    </fieldset>
  );
};

const FieldsetLabel = ({ className, children }: CompoundProps) => {
  return (
    <label className={twMerge('fieldset-label text-xs', className)}>
      {children}
    </label>
  );
};

Fieldset.displayName = 'Fieldset';
FieldsetLabel.displayName = 'Fieldset.Label';

export default Object.assign(Fieldset, {
  Label: FieldsetLabel,
});
